import React, { useState } from "react";
import className from "./SuggestOutput.module.scss";
import { getImageUrl } from "../../../../../../commons/assets_path";
import styles from "./SuggestOutput.module.scss";

type Props = {
  children: React.ReactNode;
  title: string;
  image: string;
  iconType: string;
  isSearchCompleted: boolean;
  index: number;
};

const OutputItemGroup = ({ children, title, image, iconType, isSearchCompleted, index }: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <details
      className={className.details}
      open={isSearchCompleted}
      onClick={() => setIsOpen((prev) => !prev)}
      data-testid={`outputItemGroup-${index}`}
    >
      <summary className={className.summary} style={{ zIndex: "100" }}>
        {image && <img src={iconType === "service" ? image : getImageUrl(image)} className={className.icon} />}
        <span>
          <span style={{ fontSize: "14px", fontWeight: "600" }}>{title}</span>
          <img
            src={getImageUrl("images/icons/chevron-right.svg")}
            width={24}
            height={24}
            style={{ marginLeft: "7px", marginBottom: "5px" }}
            className={`${styles.chevronRightIcon} ${isOpen || isSearchCompleted ? styles.chevronRightIconOpen : ""}`}
          />
        </span>
      </summary>
      <div className={className.content}>{children}</div>
    </details>
  );
};

export default OutputItemGroup;
